export default __webpack_public_path__ + "static/media/Restricted.12bc3c87.png";